import { client } from './API';

export function fetchWorkspaces({ communityId }) {
  return client
    .get(`/api/communities/${communityId}/workspaces`)
    .then(response => response.data);
}
